function limit(data) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  if (typeof data !== 'string') return;
  if (data.length > limit) {
    data = data.substr(0, limit - 3) + '...';
  }
  return data;
}
var RESPONSE_LIMIT = 10000;
var REQUEST_BODY_LIMIT = 10000;
function sendLog(e, etracker, config) {
  var url = e.url,
    success = e.success,
    msg = e.msg,
    status = e.status,
    code = e.code,
    duration = e.duration,
    traceId = e.traceId,
    params = e.params,
    body = e.body,
    response = e.response,
    headers = e.headers,
    rtype = e.rtype,
    method = e.method;
  var ignoreList = config.ignoreList,
    sendResponseOnSuccess = config.sendResponseOnSuccess;
  if (ignoreList) {
    if (ignoreList.some(function (rule) {
      if (typeof rule === 'string') {
        return rule === url;
      } else if (typeof rule === 'function') {
        try {
          return rule(url, e);
        } catch (e) {}
      } else if (rule instanceof RegExp) {
        return rule.test(url);
      }
    })) {
      return;
    }
  }
  etracker.log('api', {
    p1: url,
    p2: success,
    p3: msg,
    p4: status,
    p5: code,
    p6: duration,
    p7: traceId,
    p8: params,
    p9: limit(body, REQUEST_BODY_LIMIT),
    p10: !success || sendResponseOnSuccess ? limit(response, RESPONSE_LIMIT) : undefined,
    p11: headers,
    p12: rtype,
    p13: typeof method === 'string' ? method.toUpperCase() : undefined
  });
}

function isSuccess(res, httpStatus) {
  if (httpStatus !== undefined && !(httpStatus >= 200 && httpStatus < 300)) {
    return false;
  }
  return true;
}
function getMessage(res) {
  var resmsg = res.msg || res.message || res.errMsg || res.errorMessage || res.errorMsg;
  if (resmsg && resmsg.length > 50) {
    resmsg = resmsg.substring(1, 50);
  }
  return resmsg;
}
function getCode(res) {
  return res.code;
}
function getRequestBody(body, method) {
  method = method.toUpperCase();
  if (!body || method !== 'POST' && method !== 'PUT') return;
  if (typeof body === 'string') {
    return body;
  } else if (window.FormData && body instanceof FormData) {
    var fields = [];
    body.forEach(function (v, k) {
      fields.push("".concat(k, "=").concat(typeof v === 'string' ? v : Object.prototype.toString.call(v)));
    });
    return fields.join('&');
  } else if (window.URLSearchParams && body instanceof URLSearchParams) {
    return body.toString();
  } else if (window.Request && body instanceof Request) {
    return body.clone().text();
  } else {
    return Object.prototype.toString.call(body);
  }
}
function parseResponse(str, httpStatus, reqInfo, config) {
  var res = str;
  if (typeof res === 'string') {
    try {
      res = JSON.parse(str);
    } catch (e) {}
  }
  var result;
  if (Object.prototype.toString.call(res) === '[object Object]') {
    result = {
      msg: getMessage(res),
      code: getCode(res),
      success: isSuccess(res, httpStatus)
    };
  } else {
    result = {
      success: httpStatus === undefined || httpStatus >= 200 && httpStatus < 300
    };
  }
  if (typeof config.parseResponse === 'function') {
    try {
      var customize = config.parseResponse(res, httpStatus, reqInfo) || {};
      for (var i in customize) {
        result[i] = customize[i];
      }
    } catch (e) {}
  }
  return result;
}
function isIgnoreApi(original_url) {
  return original_url.indexOf('eevee-tracker-api-gateway-prod.apps-hp.danlu.netease.com') > -1 || original_url.indexOf('yeying-gateway.apps-fp.danlu.netease.com') > -1 || original_url.match(/\.(js|css|png|jpg|gif|jpeg|webp|ico|svg)(\?.*)?$/);
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

typeof TextEncoder === 'function' ? new TextEncoder() : undefined;
var b64ch = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
Array.prototype.slice.call(b64ch);
String.fromCharCode.bind(String);

function assign(o1, o2) {
  for (var i in o2) {
    o1[i] = o2[i];
  }
  return o1;
}
function isPromise(p) {
  return (typeof Promise === "undefined" ? "undefined" : _typeof(Promise)) !== undefined && p instanceof Promise;
}

function getRequestHeader(header) {
  if (window.Headers && header instanceof Headers) {
    var r = {};
    header.forEach(function (v, k) {
      r[k] = v;
    });
    return r;
  } else if (Object.prototype.toString.call(header) === '[object Object]') {
    return header;
  }
}
function getResponseBody(response, request) {
  if (request.method === 'jsonp') {
    return response.text();
  }
  var responseType = response.headers && response.headers.get ? response.headers.get('content-type') : null;
  if (!responseType || responseType.toLowerCase().indexOf('json') !== -1 || responseType.toLowerCase().indexOf('text') !== -1) {
    return response.text();
  } else {
    return "[".concat(responseType, "]");
  }
}
function hookFetch(etracker, config) {
  if (typeof window.fetch !== 'function') return;
  if (window.fetch && window.fetch.polyfill) return;
  var _fetch = window.fetch;
  window.fetch = function (arg0) {
    var setting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (setting.method === 'HEAD' || setting.mode === 'no-cors') {
      return _fetch.call(window, arg0, setting);
    }
    var original_url = arg0;
    if (isIgnoreApi(original_url)) {
      return _fetch.call(window, arg0, setting);
    }
    var original_url_s = original_url.split('?');
    var url = original_url_s[0];
    var params = original_url_s[1];
    var method = setting.method || 'GET';
    var body, headers;
    try {
      headers = getRequestHeader(setting.headers);
    } catch (e) {}
    try {
      body = getRequestBody(setting.body, method);
      if (isPromise(body)) {
        body.then(function (res) {
          body = res;
        });
      }
    } catch (e) {}

    // const sw8 = generateSw8();
    setting.headers || (setting.headers = {});
    // setting.headers.sw8 = sw8;

    var begin = new Date().getTime();
    return _fetch.call(window, arg0, setting).then(function (origin) {
      try {
        if (Object.prototype.toString.call(origin) !== '[object Response]') return origin;
        var duration = new Date().getTime() - begin;
        var res = origin.clone ? origin.clone() : origin;
        var status = res.status;
        var traceId;
        try {
          traceId = res.headers.get('sw-trace-id');
        } catch (e) {}
        var send = function send(response) {
          res = parseResponse(response, status, {
            type: 'fetch',
            params: params,
            url: url,
            body: setting.body
          }, config);
          if (res.success === false || !config.disableSendOnSuccess) {
            sendLog(assign({
              url: url,
              method: method,
              status: status,
              duration: duration,
              traceId: traceId,
              params: params,
              headers: headers,
              body: body,
              response: response,
              rtype: 'fetch'
            }, res), etracker, config);
          }
        };
        var resBody = getResponseBody(res, setting);
        if (isPromise(resBody)) {
          resBody.then(send);
        } else {
          send(resBody);
        }
      } catch (e) {}
      return origin;
    }, function (err) {
      var duration = new Date().getTime() - begin;
      var status = -1;
      var res = parseResponse('', status, {
        type: 'fetch',
        params: params,
        url: url
      }, config);
      sendLog(assign({
        url: url,
        method: method,
        success: false,
        msg: err.message,
        status: status,
        duration: duration,
        params: params,
        body: body,
        headers: headers,
        rtype: 'fetch'
      }, res), etracker, config);
      throw err;
    });
  };
}

function hookXHR(etracker, config) {
  if (typeof window.XMLHttpRequest !== 'function' || !window.addEventListener) return;
  var originXMLHttpRequest = window.XMLHttpRequest;
  var _originXMLHttpRequest = originXMLHttpRequest.prototype,
    originOpen = _originXMLHttpRequest.open,
    originSend = _originXMLHttpRequest.send,
    originSetRequestHeader = _originXMLHttpRequest.setRequestHeader;
  originXMLHttpRequest.prototype.open = function (method, url) {
    originOpen.apply(this, arguments);
    this._etrackerHook = {
      method: method,
      url: url
    };
  };
  originXMLHttpRequest.prototype.setRequestHeader = function (header, value) {
    originSetRequestHeader.apply(this, arguments);
    this._etrackerHook.headers || (this._etrackerHook.headers = {});
    this._etrackerHook.headers[header] = value;
  };
  originXMLHttpRequest.prototype.send = function (body) {
    // const sw8 = generateSw8();
    // originSetRequestHeader.call(this, 'sw8', sw8);
    originSend.apply(this, arguments);
    try {
      var _this$_etrackerHook = this._etrackerHook,
        url = _this$_etrackerHook.url,
        _this$_etrackerHook$m = _this$_etrackerHook.method,
        method = _this$_etrackerHook$m === void 0 ? 'GET' : _this$_etrackerHook$m,
        headers = _this$_etrackerHook.headers;
      delete this._etrackerHook;
      var original_url = url ? url.href || url : '';
      if (isIgnoreApi(original_url)) {
        return;
      }
      var original_url_s = original_url.split('?'),
        xhr = this,
        status = 0,
        params = original_url_s[1],
        begin = new Date().getTime();
      url = original_url_s[0];
      var parsedBody;
      try {
        parsedBody = getRequestBody(body, method);
      } catch (e) {}
      var onLoaded = function onLoaded() {
        status = xhr.status || status;
        var duration = new Date().getTime() - begin;
        var traceId;
        try {
          var resHeaders = xhr.getAllResponseHeaders();
          if (resHeaders.indexOf('sw-trace-id') !== -1) {
            traceId = xhr.getResponseHeader('sw-trace-id');
          }
        } catch (e) {}
        var responseType = xhr.responseType || 'text';
        var response;
        // 对于response只处理text和json，其他场景只记录响应类型
        if (responseType === 'text' || responseType === 'json') {
          response = xhr.response;
        } else if (xhr.response) {
          response = Object.prototype.toString.call(xhr.response);
        }
        var res = parseResponse(response || '', status, {
          type: 'xhr',
          params: params,
          url: url,
          body: body
        }, config);
        if (!res.success || !config.disableSendOnSuccess) {
          sendLog(assign({
            url: url,
            method: method,
            status: status,
            duration: duration,
            traceId: traceId,
            params: params,
            headers: headers,
            body: parsedBody,
            response: response,
            rtype: 'xhr'
          }, res), etracker, config);
        }
      };
      if (xhr.onloadend !== undefined) {
        xhr.addEventListener('abort', function (e) {
          status = -2;
        });
        xhr.addEventListener('timeout', function (e) {
          status = -3;
        });
        xhr.addEventListener('loadend', onLoaded);
      } else {
        xhr.addEventListener('readystatechange', function () {
          if (xhr.readyState === 4) {
            onLoaded();
          }
        });
      }
    } catch (e) {}
  };
}

function ETrackerPluginApi(etracker) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  config = assign(assign({}, etracker.getConfig('plugin_api')), config);
  var _config = config,
    disableHook = _config.disableHook,
    disableHookFetch = _config.disableHookFetch,
    disableHookXHR = _config.disableHookXHR;
  if (disableHook !== true) {
    disableHookFetch !== true && hookFetch(etracker, config);
    disableHookXHR !== true && hookXHR(etracker, config);
  }
  return {
    sendApi: function sendApi(data) {
      sendLog(data, etracker, config);
    }
  };
}

export { ETrackerPluginApi as default };
